import React from 'react'
import TopBar from './topBar';
import DateSelectionBar from './dateSelectionBar';
import MonthlyView from './monthlyView';
import DailyView from './dailyView';
import ListView from './listView';
import moment from 'moment';
import { connect } from 'react-redux'
import { updateDateRange, updateSnackbar, updateLoading } from '../../actions'
import { updateMobileView, updateMobileOfferForm } from '../../actions/mobileActions'
import Snackbar from '../../../../common/components/UI/Snackbar/Snackbar'
import SidePanel from './SidePanelActions/sidePanel';
import PaycodeSidePanel from './SidePanelActions/paycodeSidePanel';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons'
import * as MOBILE_CONSTANTS from './constants'
import * as Net from "../Utils/dotNet";
import * as aux from "../../../auxilaries";
import { MomentFormats } from '../../../utils';
import { removeLastSegment, getLastSegment } from '../Utils/pathHelper';
import { getMonthWeekRange } from '../Utils/momentHelper';
import { ShiftSegmentTypeName } from '../../../Enums';
import { getDstOffset } from '../../../../common-client2/src/services/ukgDateTime';

const { MONTHLY, DAILY, LIST, SIDE_PANEL, PAYCODE_SIDE_PANEL } = MOBILE_CONSTANTS;

// TODO: Import different views
class MobileBillboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentDay: moment.utc(),
            userCurrentOffset: getDstOffset(new Date(), new Date().getFullYear(), false) * 60
        }
    }
 componentDidUpdate = (prevProps) => {
        if (prevProps.shiftsLoaded !== this.props.shiftsLoaded && this.props.shiftsLoaded) {
            // When shifts load, generate calendar filters with empty manager settings
            // This allows the mobile view to render shifts immediately
            this.props.generateCalendarDefinitionAndFilters(this.props.managerSettings, this.props.storeData.monthlySchedule);
        }
    }
    async handleNextOrPrevDay(nbDays) {
        let currentDay = moment(this.state.currentDay);

        currentDay.add(nbDays, 'days');

        if (currentDay.isSame(this.state.currentDay, "month")) {
            const { refreshedDates, handleLoadToCoverOffers } = this.props;

            if (!refreshedDates.includes(moment(currentDay).format(MomentFormats.YMD))) {
                handleLoadToCoverOffers([moment(currentDay).format(MomentFormats.YMD)]);
            }

            this.setState({
                currentDay: moment(currentDay)
            });
        } else {
            await this.handleSelectMonth(currentDay);

            const { refreshedDates, handleLoadToCoverOffers } = this.props;

            if (!refreshedDates.includes(moment(currentDay).format(MomentFormats.YMD))) {
                handleLoadToCoverOffers([moment(currentDay).format(MomentFormats.YMD)]);
            }
        }
    }

    handleNextOrPrevMonth(nbMonth) {
        let currentDay = moment(this.state.currentDay);

        currentDay.add(nbMonth, 'months');

        this.handleSelectMonth(currentDay);
    }

    handleSelectMonth = async (monthStr) => {
        let currentDay = moment(monthStr);
        this.setState({
            currentDay: currentDay
        });

        const { startDate, endDate } = getMonthWeekRange(monthStr, this.props.firstDayOfTheWeek);

        this.props.updateDateRange({
            startDate: startDate.format(MomentFormats.YMD),
            endDate: endDate.format(MomentFormats.YMD),
        });
        await this.props.refreshData(false);
    }

    handleSelectDay = async (day) => {
        const { refreshedDates, handleLoadToCoverOffers } = this.props;
        const selectedDay = moment(day);
        
        // Check if the selected day is in a different month than the current view
        if (!selectedDay.isSame(this.state.currentDay, "month")) {
            // If it's a different month, update the month context first
            await this.handleSelectMonth(selectedDay);
        }
        
        this.setState({
            currentDay: selectedDay
        }, () => this.changeView(DAILY));
        
        if (!refreshedDates.includes(selectedDay.format(MomentFormats.YMD))) {
            handleLoadToCoverOffers([selectedDay.format(MomentFormats.YMD)]);
        }
    }

    changeView(view) {
        this.props.updateMobileView(view);
    }

    closeSnackbar = () => {
        this.props.updateSnackbar({
            messageSnackbar: '',
            openSnackbar: false
        })
    }

    fetchExtraDetails = async (offerId, requestType) => {
        const { options, updateLoading, updateSnackbar } = this.props;
        var extraDetails = undefined;

        updateLoading(true);
        await Net.GetExtraDetails(options, offerId, requestType).then(async response => {
            extraDetails = response.data;
            updateLoading(false);
        }).catch(err => {
            let message = aux.handleAPIErrors(err.response)
            updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: message,
                openSnackbar: true,
            })
            updateLoading(false);
        });

        return extraDetails;
    }

    handleHistoryClick = async (historyOffer) => {
        const {
            storeData, updateMobileOfferForm, managerSettings, updateMobileView,
        } = this.props;

        const shiftOffer = storeData.employeeShiftOffers.find(x => x.offerId === historyOffer.offerId);

        if (shiftOffer) {
            let setting = managerSettings.find(y => y.id === shiftOffer.managerSettingId);
            const extraData = await this.fetchExtraDetails(shiftOffer.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: [shiftOffer.shift],
                    managerSetting: setting,
                    status: shiftOffer.status,
                    source: 0,
                    type: setting.type,
                    offerId: shiftOffer.offerId,
                    raw: shiftOffer,
                    history: extraData.history,
                    isAvailableOffer: false
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const shiftRequest = storeData.employeeShiftRequests.find(x => x.offerId === historyOffer.offerId);

        if (shiftRequest) {
            let setting = managerSettings.find(y => y.id === shiftRequest.managerSettingId);
            const extraData = await this.fetchExtraDetails(shiftRequest.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: [shiftRequest.shift],
                    managerSetting: setting,
                    status: shiftRequest.status,
                    source: 1,
                    type: setting.type,
                    offerId: shiftRequest.offerId,
                    raw: shiftRequest,
                    history: extraData.history,
                    isAvailableOffer: false
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const shiftSwap = storeData.employeeMyShiftSwapOffers.find(x => x.offerId === historyOffer.offerId);

        if (shiftSwap) {
            let setting = managerSettings.find(y => y.id === shiftSwap.managerSettingId);
            const extraData = await this.fetchExtraDetails(shiftSwap.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: shiftSwap.shifts,
                    managerSetting: setting,
                    status: shiftSwap.status,
                    source: 0,
                    type: setting.type,
                    offerId: shiftSwap.offerId,
                    proposals: shiftSwap.proposals,
                    raw: shiftSwap,
                    history: extraData.history,
                    isAvailableOffer: false,
                    isProposedByOfferer: shiftSwap.isProposedByOfferer,
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const proposal = storeData.myProposals.find(x => x.offerId === historyOffer.offerId);

        if (proposal) {
            let setting = managerSettings.find(y => y.id === proposal.managerSettingId);
            const extraData = await this.fetchExtraDetails(proposal.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: proposal.shifts,
                    managerSetting: setting,
                    status: proposal.status,
                    source: 0,
                    type: setting.type,
                    offerId: proposal.offerId,
                    proposals: proposal.proposals,
                    raw: proposal,
                    history: extraData.history,
                    isAvailableOffer: false,
                    isProposedByOfferer: proposal.isProposedByOfferer,
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const openShiftRequest = storeData.myOpenShiftRequests.find(x => x.id === historyOffer.offerId);

        if (openShiftRequest) {
            let setting = managerSettings.find(y => y.id === openShiftRequest.managerSettingId);
            const extraData = await this.fetchExtraDetails(openShiftRequest.id, setting.type);
            updateMobileOfferForm(
                {
                    shifts: [openShiftRequest.shift],
                    managerSetting: setting,
                    source: 0,
                    status: openShiftRequest.status,
                    type: 2,
                    offerId: openShiftRequest.id,
                    history: extraData.history,
                    raw: openShiftRequest
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const vtoRequest = storeData.myVTORequests.find(x => x.offerId === historyOffer.offerId);

        if (vtoRequest) {
            let setting = managerSettings.find(y => y.id === vtoRequest.managerSettingId);
            const extraData = await this.fetchExtraDetails(vtoRequest.offerId, setting.type);
            updateMobileOfferForm(
                {
                    managerSetting: setting,
                    source: 0,
                    status: vtoRequest.status,
                    type: 3,
                    offerId: vtoRequest.offerId,
                    raw: vtoRequest,
                    history: extraData.history,
                    isAvailableOffer: false
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const shiftToCover = storeData.availableShiftsToCover.find(x => x.offerId === historyOffer.offerId);

        if (shiftToCover) {
            let setting = managerSettings.find(y => y.id === shiftToCover.managerSettingId);
            const extraData = await this.fetchExtraDetails(shiftToCover.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: [shiftToCover.shift],
                    managerSetting: setting,
                    source: 1,
                    type: 0,
                    raw: shiftToCover,
                    history: extraData.history,
                    isAvailableOffer: true
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const shiftToSwapOffer = storeData.availableShiftToSwapOffers.find(x => x.offerId === historyOffer.offerId);

        if (shiftToSwapOffer) {
            let setting = managerSettings.find(y => y.id === shiftToSwapOffer.managerSettingId);
            const extraData = await this.fetchExtraDetails(shiftToSwapOffer.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: shiftToSwapOffer.shifts,
                    managerSetting: setting,
                    source: 1,
                    type: 1,
                    status: shiftToSwapOffer.status,
                    raw: shiftToSwapOffer,
                    offerId: shiftToSwapOffer.offerId,
                    history: extraData.history,
                    isAvailableOffer: true
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const openShift = storeData.availableOpenShifts.find(x => x.offerId === historyOffer.offerId);

        if (openShift) {
            let setting = managerSettings.find(y => y.id === openShift.managerSettingId);
            const extraData = await this.fetchExtraDetails(openShift.offerId, setting.type);
            updateMobileOfferForm(
                {
                    shifts: openShift.shifts,
                    managerSetting: setting,
                    source: 1,
                    type: 2,
                    raw: [{ ...openShift, managerSettingId: setting.id }],
                    history: extraData.history,
                    isAvailableOffer: true
                }
            )
            updateMobileView(SIDE_PANEL);
        }

        const vto = storeData.availableVTO.find(x => x.offerId === historyOffer.offerId);

        if (vto) {
            let setting = managerSettings.find(y => y.id === vto.managerSettingId);
            const extraData = await this.fetchExtraDetails(vto.offerId, setting.type);

            updateMobileOfferForm(
                {
                    managerSetting: setting,
                    source: 1,
                    type: 3,
                    offerId: vto.offerId,
                    raw: vto,
                    history: extraData.history,
                    isAvailableOffer: true
                }
            )
            updateMobileView(SIDE_PANEL);
        }

    }

    isIncludedInLocationFilter(shiftSegments, locations, isTransferIncluded) {
        const segments = isTransferIncluded 
            ? shiftSegments.filter(x => x.type !== ShiftSegmentTypeName.BREAK_SEGMENT) 
            : shiftSegments.filter((segment) => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT && segment.type !== ShiftSegmentTypeName.TRANSFER_SEGMENT);
        return segments.some((segment) => locations.includes(removeLastSegment(segment.orgJobRef.qualifier)));
    } 

    isIncludedInJobFilter(shiftSegments, jobs, isTransferIncluded) {
        const segments = isTransferIncluded 
            ? shiftSegments.filter(x => x.type !== ShiftSegmentTypeName.BREAK_SEGMENT) 
            : shiftSegments.filter((segment) => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT && segment.type !== ShiftSegmentTypeName.TRANSFER_SEGMENT);
        return segments.some((segment) => jobs.includes(getLastSegment(segment.orgJobRef.qualifier)));
    }

    sortDataByDays() {
        const { storeData, filters } = this.props;
        const { currentDay } = this.state;
        const key = MomentFormats.YYMMDD;
        let shiftsCalendar = [], paycodeCalendar = [], tcOffers = [], ssOffers = [], osOffers = [], vtoOffers = [],
        myTcRequests = [], myTcOffers = [], mySwapOffers = [], myProposals = [], myOpenShiftRequests = [], myVTORequests = [];

        const locationCheckedValues = filters.location.filters.filter(x => x.checked).map(x => x.name);
        const isLocationTransferIncluded = filters.location.isTransferIncluded;
        const jobCheckedValues = filters.job.filters.filter(x => x.checked).map(x => x.name);
        const isJobTransferIncluded = filters.job.isTransferIncluded;

        for (const x of storeData.employeeShifts) {
            if (!this.isIncludedInLocationFilter(x.segments, locationCheckedValues, isLocationTransferIncluded)
                || !this.isIncludedInJobFilter(x.segments, jobCheckedValues, isJobTransferIncluded)){
                continue
            }
            if (shiftsCalendar[moment.utc(x.startDateTime).format(key)] === undefined) {
                shiftsCalendar[moment.utc(x.startDateTime).format(key)] = [x];
            } else {
                shiftsCalendar[moment.utc(x.startDateTime).format(key)].push(x);
            }
        }

        for (const x of storeData.employeePaycodes) {
            if (paycodeCalendar[moment.utc(x.startDateTime).format(key)] === undefined) {
                paycodeCalendar[moment.utc(x.startDateTime).format(key)] = [x];
            } else {
                paycodeCalendar[moment.utc(x.startDateTime).format(key)].push(x);
            }
        }

        let setting, status;

        for (const x of storeData.availableShiftsToCover) {
            if (!this.isIncludedInLocationFilter(x.shift?.segments, locationCheckedValues, isLocationTransferIncluded)
                || !this.isIncludedInJobFilter(x.shift?.segments, jobCheckedValues, isJobTransferIncluded)){
                continue
            }
            setting = filters.myItem.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                let startDate = x.partialFromDate ? moment.utc(x.partialFromDate) : moment.utc(x.shift.startDateTime)
                if (tcOffers[startDate.format(key)] === undefined) {
                    tcOffers[startDate.format(key)] = [x];
                } else {
                    tcOffers[startDate.format(key)].push(x);
                }
            }
        }

        for (const x of storeData.availableShiftToSwapOffers) {
            let applicableFilter;

            if (x.isSkipValidation) {
                applicableFilter = filters.skipValidationOffers.filters.find(e =>
                    e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())
                );
            } else {
                applicableFilter = filters.myItem.filters.find(e =>
                    e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())
                );
            }

            let statusFilter = filters.status.filters.find(e =>
                (e.statusIds && e.statusIds.includes(x.status)) ||
                (e.statusId && e.statusId === x.status)
            );

            if ((!applicableFilter || applicableFilter.checked) && (!statusFilter || statusFilter.checked)) {
                for (const shift of x.shifts) {
                    if (
                        !this.isIncludedInLocationFilter(shift.segments, locationCheckedValues, isLocationTransferIncluded) ||
                        !this.isIncludedInJobFilter(shift.segments, jobCheckedValues, isJobTransferIncluded)
                    ) {
                        continue;
                    }
                    let startDate = x.partialFromDate ? moment.utc(x.partialFromDate) : moment.utc(shift.startDateTime);
                    if (ssOffers[moment.utc(startDate).format(key)] === undefined) {
                        ssOffers[moment.utc(startDate).format(key)] = [x];
                    } else {
                        ssOffers[moment.utc(startDate).format(key)].push(x);
                    }
                }
            }
        }

        for (const x of storeData.availableOpenShifts) {
            let visible = false;
            for (const ms of (x.managerSettings || [])) {
                setting = filters.myItem.filters.find(e => (e.calendarIds && e.calendarIds.includes(ms.managerSettingId.toString())));
                visible = visible || (setting && setting.checked);
            }

            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(0)) || (e.statusId && e.statusId === 0));

            if (visible) {
                visible = x.shifts.some((shift) => {
                    return this.isIncludedInLocationFilter(shift.segments, locationCheckedValues, isLocationTransferIncluded);
                });
            }

            if (visible) {
                visible = x.shifts.some((shift) => {
                    return this.isIncludedInJobFilter(shift.segments, jobCheckedValues, isJobTransferIncluded);
                });
            }

            if (visible && (!status || status.checked)) {
                if (osOffers[moment.utc(x.startDate).format(key)] === undefined) {
                    osOffers[moment.utc(x.startDate).format(key)] = [x];
                } else {
                    osOffers[moment.utc(x.startDate).format(key)].push(x);
                }
            }
        }

        for (const x of storeData.availableVTO) {
            setting = filters.myItem.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                if (x.voluntaryTimeOffType !== 1) {
                    if (vtoOffers[moment.utc(x.timeOffStartDate).format(key)] === undefined) {
                        vtoOffers[moment.utc(x.timeOffStartDate).format(key)] = [x];
                    } else {
                        vtoOffers[moment.utc(x.timeOffStartDate).format(key)].push(x);
                    }
                } else {
                    let day = moment.utc(x.timeOffStartDate);
                    if (day.format(MomentFormats.Month) < currentDay.format(MomentFormats.Month)) {
                        day = moment.utc(currentDay).startOf("month");
                    }
                    let placed = false;
                    while (!placed && day.format(MomentFormats.Month) === currentDay.format(MomentFormats.Month)) {
                        if (shiftsCalendar[day.format(key)]) {
                            if (vtoOffers[day.format(key)] === undefined) {
                                vtoOffers[day.format(key)] = [x];
                            } else {
                                vtoOffers[day.format(key)].push(x);
                            }
                            placed = true;
                        } else {
                            day.add(1, 'days');
                        }
                    }
                }
            }
        }

        for (const x of storeData.employeeShiftRequests) {
            if (!this.isIncludedInLocationFilter(x.shift?.segments, locationCheckedValues, isLocationTransferIncluded)
                || !this.isIncludedInJobFilter(x.shift?.segments, jobCheckedValues, isJobTransferIncluded)){
                continue
            }
          
            setting = filters.myRequest.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                let startDate = x.partialFromDate ? moment.utc(x.partialFromDate) : moment.utc(x.shift.startDateTime)
                if (myTcRequests[startDate.format(key)] === undefined) {
                    myTcRequests[startDate.format(key)] = [x];
                } else {
                    myTcRequests[startDate.format(key)].push(x);
                }
            }
        }

        for (const x of storeData.employeeShiftOffers) {
            if (!this.isIncludedInLocationFilter(x.shift.segments, locationCheckedValues, isLocationTransferIncluded)
                || !this.isIncludedInJobFilter(x.shift.segments, jobCheckedValues, isJobTransferIncluded)) {
                continue
            }

            setting = filters.myRequest.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                let startDate = moment.utc(x.shift.startDateTime)
                if (myTcOffers[startDate.format(key)] === undefined) {
                    myTcOffers[startDate.format(key)] = [x];
                } else {
                    myTcOffers[startDate.format(key)].push(x);
                }
            }
        }

        for (const x of storeData.employeeMyShiftSwapOffers) {
            setting = filters.myRequest.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                for (const shift of x.shifts) {
                    if (!this.isIncludedInLocationFilter(shift.segments, locationCheckedValues, isLocationTransferIncluded)
                        || !this.isIncludedInJobFilter(shift.segments, jobCheckedValues, isJobTransferIncluded)) {
                        continue
                    }
                    if (mySwapOffers[moment.utc(shift.startDateTime).format(key)] === undefined) {
                        mySwapOffers[moment.utc(shift.startDateTime).format(key)] = [x];
                    } else {
                        mySwapOffers[moment.utc(shift.startDateTime).format(key)].push(x);
                    }
                }
            }
        }

        for (const x of storeData.myProposals) {
            setting = filters.myRequest.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                for (const proposal of x.proposals) {
                    for (const shift of proposal.shifts) {
                        if (!this.isIncludedInLocationFilter(shift.segments, locationCheckedValues, isLocationTransferIncluded)
                            || !this.isIncludedInJobFilter(shift.segments, jobCheckedValues, isJobTransferIncluded)) {
                            continue
                        }

                        if (myProposals[moment.utc(shift.startDateTime).format(key)] === undefined) {
                            myProposals[moment.utc(shift.startDateTime).format(key)] = [x];
                        } else {
                            myProposals[moment.utc(shift.startDateTime).format(key)].push(x);
                        }
                    }
                }
            }
        }

        for (const x of storeData.myOpenShiftRequests) {
            if (!this.isIncludedInLocationFilter(x.shift.segments, locationCheckedValues, isLocationTransferIncluded)
                || !this.isIncludedInJobFilter(x.shift.segments, jobCheckedValues, isJobTransferIncluded)) {
                continue
            }
            setting = filters.myRequest.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(0)) || (e.statusId && e.statusId === 0));

            if ((!setting || setting.checked) && (!status || status.checked)) {
                if (myOpenShiftRequests[moment.utc(x.startDate).format(key)] === undefined) {
                    myOpenShiftRequests[moment.utc(x.startDate).format(key)] = [x];
                } else {
                    myOpenShiftRequests[moment.utc(x.startDate).format(key)].push(x);
                }
            }
        }

        for (const x of storeData.myVTORequests) {
            setting = filters.myRequest.filters.find(e => (e.calendarIds && e.calendarIds.includes(x.managerSettingId.toString())));
            status = filters.status.filters.find(e => (e.statusIds && e.statusIds.includes(x.status)) || (e.statusId && e.statusId === x.status));
            if ((!setting || setting.checked) && (!status || status.checked)) {
                if (x.voluntaryTimeOffType === 0 || x.voluntaryTimeOffType === 2) {
                    if (myVTORequests[moment.utc(x.timeOffStartDate).format(key)] === undefined) {
                        myVTORequests[moment.utc(x.timeOffStartDate).format(key)] = [x];
                    } else {
                        myVTORequests[moment.utc(x.timeOffStartDate).format(key)].push(x);
                    }
                } else {
                    let dateToPutRequest;
                    if (x.approvedShifts.length) {
                        dateToPutRequest = x.approvedShifts[0].shift.startDateTime;
                    }
                    else if (x.affectedShifts.length) {
                        dateToPutRequest = x.affectedShifts[0].startDateTime;
                    } else {
                        dateToPutRequest = x.timeOffStartDate;
                    }

                    if (myVTORequests[moment.utc(x.timeOffStartDate).format(key)] === undefined) {
                        myVTORequests[moment.utc(dateToPutRequest).format(key)] = [x];
                    } else {
                        myVTORequests[moment.utc(dateToPutRequest).format(key)].push(x);
                    }
                }
            }
        }

        let shiftsFilter = filters.myItem.filters.find(e => e.id === 0);
        let paycodesFilter = filters.myItem.filters.find(e => e.id === 1);

        shiftsCalendar = shiftsFilter && shiftsFilter.checked ? shiftsCalendar : [];
        paycodeCalendar = paycodesFilter && paycodesFilter.checked ? paycodeCalendar : [];

        return {
            shiftsCalendar,
            paycodeCalendar,
            tcOffers,
            ssOffers,
            osOffers,
            vtoOffers,
            myTcRequests,
            myTcOffers,
            mySwapOffers,
            myProposals,
            myOpenShiftRequests,
            myVTORequests
        };
    }

    handleLoadToCoverOffers = async (dates, spinner = true) => {
        let errMsg = await this.props.handleLoadToCoverOffers(dates, spinner);
        if (errMsg) {
            this.handleSnackbar('error', errMsg, true);
        }
    }

    renderView = () => {
        const { mobileView, firstDayOfTheWeek, person, refreshData, buildInfos } = this.props;
        const { currentDay } = this.state;

        let { shiftsCalendar, paycodeCalendar, tcOffers, ssOffers, osOffers, vtoOffers, myTcRequests, myTcOffers, mySwapOffers, myProposals, myOpenShiftRequests, myVTORequests } = this.sortDataByDays();

        let topBar = <TopBar
            person={person}
            buildInfos={buildInfos}
            monthlyViewMenuClick={() => { this.changeView(MONTHLY) }}
            listViewMenuClick={() => { this.changeView(LIST) }}
            dailyViewMenuClick={() => { this.changeView(DAILY) }}
            onHistoryElementClick={(offerId) => { this.handleHistoryClick(offerId) }}
            handleLoadToCoverOffers={this.handleLoadToCoverOffers}
        />;

        let monthDateSelector = <DateSelectionBar
            rangeType={DateSelectionBar.rangeTypes.month}
            currentDay={currentDay}
            dateIcon={faAngleDown}
            handlePrevious={() => { this.handleNextOrPrevMonth(-1) }}
            handleNext={() => { this.handleNextOrPrevMonth(1) }}
            handleSelectMonth={this.handleSelectMonth}
        />;

        let dayDateSelector = <DateSelectionBar
            rangeType={DateSelectionBar.rangeTypes.day}
            currentDay={currentDay}
            handlePrevious={() => { this.handleNextOrPrevDay(-1) }}
            handleNext={() => { this.handleNextOrPrevDay(1) }}
            handleDayClick={() => { this.changeView(MONTHLY) }}
        />;

        /** @type {typeof MOBILE_CONSTANTS[keyof typeof MOBILE_CONSTANTS]} */
        const currentMobileView = mobileView.current;

        switch (currentMobileView) {
            case MONTHLY:
                return (
                    <>
                        {topBar}
                        {monthDateSelector}
                        <MonthlyView
                            firstDayOfTheWeek={firstDayOfTheWeek}
                            currentMonth={currentDay}
                            onDayClick={this.handleSelectDay}

                            employeeShifts={shiftsCalendar}
                            employeePaycodes={paycodeCalendar}

                            toCoverOffers={tcOffers}
                            availableShiftOffers={ssOffers}
                            availableOpenShifts={osOffers}
                            availableVTO={vtoOffers}

                            myToCoverRequests={myTcRequests}
                            myToCoverOffers={myTcOffers}
                            mySwapOffers={mySwapOffers}
                            myProposals={myProposals}
                            myOpenShiftRequests={myOpenShiftRequests}
                            myVTORequests={myVTORequests}
                        />
                    </>
                );
            case DAILY:
                return (
                    <>
                        {topBar}
                        {dayDateSelector}
                        <DailyView
                            currentDay={currentDay}
                            employeeShifts={shiftsCalendar}
                            employeePaycodes={paycodeCalendar}

                            toCoverOffers={tcOffers}
                            availableShiftOffers={ssOffers}
                            availableOpenShifts={osOffers}
                            availableVTO={vtoOffers}

                            myToCoverRequests={myTcRequests}
                            myToCoverOffers={myTcOffers}
                            mySwapOffers={mySwapOffers}
                            myProposals={myProposals}
                            myOpenShiftRequests={myOpenShiftRequests}
                            myVTORequests={myVTORequests}
                        />
                    </>
                )
            case LIST:
                return (
                    <>
                        {topBar}
                        {monthDateSelector}
                        <ListView
                            currentDay={currentDay}
                            onDayClick={this.handleSelectDay}

                            employeeShifts={shiftsCalendar}
                            employeePaycodes={paycodeCalendar}

                            toCoverOffers={tcOffers}
                            availableShiftOffers={ssOffers}
                            availableOpenShifts={osOffers}
                            availableVTO={vtoOffers}

                            myToCoverRequests={myTcRequests}
                            myToCoverOffers={myTcOffers}
                            mySwapOffers={mySwapOffers}
                            myProposals={myProposals}
                            myOpenShiftRequests={myOpenShiftRequests}
                            myVTORequests={myVTORequests}
                        />

                    </>
                );
            case SIDE_PANEL:
                return (
                    <SidePanel
                        handleSnackbar
                        refreshData={refreshData}
                    />
                );
            case PAYCODE_SIDE_PANEL:
                return <PaycodeSidePanel />;

            default: // Should return monthly view by default
                return <>{topBar}</>;
        }
    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        });
    }

    render() {
        const { snackbar = {} } = this.props;
        return (
            <div style={{ width: '100%', overflow: 'hidden' }}>
                {this.renderView()}
                <Snackbar
                    type={snackbar.typeSnackbar || 'info'}
                    message={snackbar.messageSnackbar || ''}
                    open={snackbar.openSnackbar || false}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                    closeSnackbar={this.closeSnackbar}
                    vertical={'bottom'}
                />
            </div>
        )
    }
}
const mapStateToProps = state => ({
    formData: state.mobileOfferShiftForm,
    employeeShiftOffers: state.data.employeeShiftOffers,
    storeData: state.data,
    loading: state.loadingState,
    options: state.httpOptions,
    snackbar: state.snackbar,
    mobileView: state.mobileView,
    managerSettings: state.managerSettings,
    person: state.person,
    buildInfos: state.buildInfos,
    filters: state.filters,
    refreshedDates: state.refreshedDates,
});

const mapDispatchToProps = dispatch => ({
    updateDateRange: payload => dispatch(updateDateRange(payload)),
    updateSnackbar: payload => dispatch(updateSnackbar(payload)),
    updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
    updateMobileView: payload => dispatch(updateMobileView(payload)),
    updateLoading: payload => dispatch(updateLoading(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileBillboard);
